// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"7f0cfaa6","280":"cbb2656a","342":"1c5fb02e","731":"6e66f438"}[chunkId] + ".css";
};